module.exports = __webpack_public_path__ + "23acaad552c1350f6599c037d13d7ac5.pdf";